import { render, staticRenderFns } from "./SelfCheck.vue?vue&type=template&id=7662100e"
import script from "./SelfCheck.vue?vue&type=script&lang=ts"
export * from "./SelfCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports